/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type PosSortByParam =
  (typeof PosSortByParam)[keyof typeof PosSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PosSortByParam = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  POSTCODE_ASC: "POSTCODE_ASC",
  POSTCODE_DESC: "POSTCODE_DESC",
  UPDATED_AT_ASC: "UPDATED_AT_ASC",
  UPDATED_AT_DESC: "UPDATED_AT_DESC",
} as const;
